import { render, staticRenderFns } from "./CreateIncidentModal.vue?vue&type=template&id=6479c3a4&scoped=true"
import script from "./CreateIncidentModal.ts?vue&type=script&lang=ts&external"
export * from "./CreateIncidentModal.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateIncidentModal.scss?vue&type=style&index=0&id=6479c3a4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479c3a4",
  null
  
)

export default component.exports